export default "__VITE_ASSET__73fc7502__"